import { render, staticRenderFns } from "./WaitSettings.vue?vue&type=template&id=97e8ca26&scoped=true"
import script from "./WaitSettings.vue?vue&type=script&lang=js"
export * from "./WaitSettings.vue?vue&type=script&lang=js"
import style0 from "./WaitSettings.vue?vue&type=style&index=0&id=97e8ca26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e8ca26",
  null
  
)

export default component.exports